( function( $ ) {

    /*AOS init*/
    $(window).on("load",function(){
        AOS.init();
    });
    /*AOS init*/

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('.js-hMenu').slideToggle();
    });

    $(document).click(function(e) {
        if (
            !$(e.target).closest('.js-hMenuBtn').length &&
            !$(e.target).closest('.js-hMenu').length
        ) {
            $('.js-hMenuBtn').removeClass('active');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        $('.js-hMenuBtn').removeClass('active');
        $('.js-hMenu').slideUp();
    });
    /*header menu*/

    /*anchors clicks*/
    $(document).on('click', 'a[href*="#"]', function (e) {
        const href = $(this).attr('href');

        // абсолютний URL з href
        const link = document.createElement('a');
        link.href = href;

        const targetId = link.hash;
        if (!targetId) return;

        const $target = $(targetId);

        const sameOrigin = link.origin === location.origin;
        const samePath =
            link.pathname.replace(/\/$/, '') ===
            location.pathname.replace(/\/$/, '');

        // 🔹 Ми на тій самій сторінці
        if (sameOrigin && samePath && $target.length) {
            e.preventDefault();

            const duration = 1600;
            const startY = window.pageYOffset;
            const startTime = performance.now();

            function easeOutCubic(t) {
                return 1 - Math.pow(1 - t, 3);
            }

            function animate(now) {
                const elapsed = now - startTime;
                const progress = Math.min(elapsed / duration, 1);

                const targetY = $target.offset().top;
                const distance = targetY - startY;

                window.scrollTo(
                    0,
                    startY + distance * easeOutCubic(progress)
                );

                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            }

            requestAnimationFrame(animate);
            return;
        }

        // 🔹 Інша сторінка — віддаємо браузеру
        // (ніяких preventDefault)
    });
    /*anchors clicks*/

    /*video*/
    $(document).ready(function () {
        var iframe = $('#vimeo-player')[0];
        var player = new Vimeo.Player(iframe);
        player.getVolume().then(function (volume) {
            player.setVolume(0);
        });

        function toggleSound(_this) {
            player.getVolume().then(function (volume) {
                _this.find('.sound').removeClass('active');
                if (volume > 0) {
                    player.setVolume(0);
                    _this.find('.sound[data-sound="disabled"]').addClass('active');
                } else {
                    player.setVolume(1);
                    _this.find('.sound[data-sound="enabled"]').addClass('active');
                }
            });
        }

        $('.js-firstLoud').on('click', function () {
            toggleSound($(this));
        });
    });
    /*video*/

    /*main traitments*/
    $(document).ready(function() {
        $('.js-mainTraitsTags').each(function(i){
            $(this).marquee({
                duration: 25000,
                gap: 0,
                delayBeforeStart: 0,
                direction: ((i % 2) === 0) ? 'left' : 'right',
                //true or false - should the marquee be duplicated to show an effect of continues flow
                duplicated: true,
                //duplicate the message three times
                duplicateCount: 1
            });
        });
    });
    /*main traitments*/

    /*page conseils faq*/
    $('.js-pageConsFaqTab').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageConsFaqTabCont').slideDown();
        } else if ($('.js-pageConsFaqTab.active').data('id') === 'all') {
            $('.js-pageConsFaqTabCont:not([data-id="'+id+'"])').slideUp();
        } else {
            $('.js-pageConsFaqTabCont').slideUp();
            $('.js-pageConsFaqTabCont[data-id="'+id+'"]').slideDown();
        }
        $('.js-pageConsFaqTab').removeClass('active')
        $(this).addClass('active')
    })
    $('.js-pageConsFaqBurg').click(function(){
        $('.js-pageConsFaqBurg').removeClass('active')
        $('.js-pageConsFaqBurgWrap').removeClass('active')
        $('.js-pageConsFaqBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageConsFaqBurgWrap').addClass('active')
        $(this).siblings('.js-pageConsFaqBurgTxt').slideDown()
    })
    /*page conseils faq*/

    /*page conseils docs slider*/
    $('.js-pageConsDocsSlider').each(function(){
        $(this).on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
            var cnt = slick.options.slidesToScroll;
            var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
            $('.js-pageConsDocsSliderCounter').html(
                '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
            );
        });

        $('.js-pageConsDocsSlider').slick({
            arrows: true,
            centerMode: false,
            slidesToShow: 3,
            prevArrow: '<button class="arrow prev-arrow"><svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0 9.99463L5 12.8814V7.10788L0 9.99463ZM4.5 9.99463V10.4946H60V9.99463V9.49463H4.5V9.99463Z" fill="#031D34"/> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M60 9.99463L55 7.10788V12.8814L60 9.99463ZM0 9.99463V10.4946H55.5V9.99463V9.49463H0V9.99463Z" fill="#031D34"/> </svg></button>',
            appendArrows: $('.js-pageConsDocsSliderArrows'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    });
    /*page conseils docs slider*/

    /*page cabinet gal slider*/
    $('.js-pageCabinetGalSlider').each(function(){
        $(this).on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
            var cnt = slick.options.slidesToScroll;
            var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
            $('.js-pageCabinetGalSliderCounter').html(
                '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
            );
        });

        $('.js-pageCabinetGalSlider').slick({
            arrows: true,
            centerMode: false,
            slidesToShow: 1,
            prevArrow: '<button class="arrow prev-arrow"><svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0 9.99463L5 12.8814V7.10788L0 9.99463ZM4.5 9.99463V10.4946H60V9.99463V9.49463H4.5V9.99463Z" fill="#031D34"/> </svg></button>',
            nextArrow: '<button class="arrow next-arrow"><svg width="60" height="20" viewBox="0 0 60 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M60 9.99463L55 7.10788V12.8814L60 9.99463ZM0 9.99463V10.4946H55.5V9.99463V9.49463H0V9.99463Z" fill="#031D34"/> </svg></button>',
            appendArrows: $('.js-pageCabinetGalSliderArrows')
        });
    });
    /*page conseils docs slider*/

    /*page cabinet tech*/

    $(document).on("mouseover", ".js-pageCabinetTechItem", function() {
        if ($(window).width() >= 992) {
            if (!$(this).hasClass("active") && !$(this).closest('.js-pageCabinetTechItem').hasClass("active")) {
                $('.js-pageCabinetTechItem').removeClass("active");
                $('.js-pageCabinetTechItemTxt').stop(true, true).slideUp(250);
                $('.js-pageCabinetTechItemImg').removeClass("active");
                $(this).addClass("active");
                $(this).find('.js-pageCabinetTechItemTxt').stop(true, true).slideDown(250);
                $('.js-pageCabinetTechItemImg[data-tech="'+$(this).data('tech')+'"]').addClass("active");
            }
        }
    });

    $('.js-pageCabinetTechItem').click(function(e) {
        if ($(window).width() < 992) {
            e.preventDefault();
            $('.js-pageCabinetTechItem').removeClass("active");
            $('.js-pageCabinetTechItemTxt').stop(true, true).slideUp(250);
            $('.js-pageCabinetTechItemImg').removeClass("active");
            $(this).addClass("active");
            $(this).find('.js-pageCabinetTechItemTxt').stop(true, true).slideDown(250);
            $('.js-pageCabinetTechItemImg[data-tech="'+$(this).data('tech')+'"]').addClass("active");
        }
    });
    /*page cabinet tech*/

    /*scroll equipe*/
    $(window).on('load resize', function(){
        if ($('.js-scrollEquipe').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-scrollEquipe').offset().top;
                var singleSidebarRailTop = $('.js-scrollEquipeRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-scrollEquipe').outerHeight();
                var singleSidebarMenuH = $('.js-scrollEquipeCont').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-scrollEquipeRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-scrollEquipeRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 0;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-scrollEquipeCont').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-scrollEquipeCont').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-scrollEquipeCont').css('top', '0')
                    }
                })
            } else {
                $('.js-scrollEquipeRail').css('height', 'auto')
            }
        }
    })
    /*scroll equipe*/

    $('.js-icoTilt').tilt({
        perspective: 50,
    })

    /*wpcf file*/
    $('.js-formFileBtn').click(function(){
        $('.js-formFile').click();
    })
    $('.js-formFile').change(function(){
        var ttt  = $('.js-formFile').val()
        var arr = ttt.split('\\')
        $('.js-formFileBtn .txt').html(arr[arr.length-1]);
    })
    /*wpcf file*/

    $(document).ready(function() {
        $('.js-formSelect').select2({
            dropdownParent: $('.js-formSelect').parent()
        });
    });

}( jQuery ) );
